import {useNavigate, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {State} from "@App/state";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const useRedirectBack = () => {

    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const slot = useSelector((state: State) => state.orders.service)

    const redirectOnMissingParams = (neededParams: string[], redirectTo: string) => {
        let checks = neededParams.map((param) => {
            switch (param) {
                case 'garage':
                    return !!searchParams.get('garage') && searchParams.get('garage') !== 'null'
                case 'service':
                    return !!searchParams.get('service') && searchParams.get('service') !== 'null'
                case 'place':
                    return !!searchParams.get('place') && searchParams.get('place') !== 'null'
                case 'slot':
                    return !!slot || (!!searchParams.get('slot') && searchParams.get('slot') !== 'null')
            }
        })

        if (checks.indexOf(false) > -1) {
            navigate(redirectTo + '?' + searchParams.toString())
        }
    }

    return {redirectOnMissingParams}
}
